<template lang="pug">
  .component-credit-records
    ActionBar
      h2(slot="title") {{type}} Credit
      i.fa.fa-plus-circle.fa-2x(slot="action", v-if="expanded", @click="addCredit = !addCredit")
      i.fa.fa-2x(slot="action", :class="{'fa-eye-slash':expanded, 'fa-eye':!expanded}", @click="expanded = !expanded")
    .add-credit(v-if="addCredit")
      label Amount
        input(type="number" v-model="body.amount")
      ActionButton(:action="addNewCredit") Add Credit
      // button.button Add credit
    base-list(ref="listCr", v-if="expanded", :component="component", :search="search", :dataLoader="dataLoader", :resultsPerPage="5")


</template>

<script>
  import KeplerBackofficeSdk from '../../../lib/kepler/backoffice'
  import BaseList from '../../../pages/backoffice/BaseList'
  import ActionBar from '../../structure/ui/ActionBar'
  import DatePicker from '../../structure/DatePicker'
  import ActionButton from '../../structure/ui/ActionButton'
  import {mapState} from 'vuex'
  import ToggleableButton from '../../structure/ui/ToggleableButton'

  export default {
    name: 'TabbedPaidCreditRecords',
    components: {ToggleableButton, ActionButton, DatePicker, ActionBar, BaseList},
    data() {
      return {
        component: require('src/components/backoffice/CreditRecord'),
        expanded: true,
        addCredit: false,
        body: {
          amount: 0,
        }
      }
    },
    created() {
    },
    methods: {
      dataLoader(callback, page = 1, resultsPerPage = 5) {
        KeplerBackofficeSdk.credits.list.all(this.search, page, resultsPerPage, (data) => {
          callback(data)
        })
      },
      addNewCredit() {
        const body = {
          ...this.body,
          client_id: this.$route.params.id,
        }
        return KeplerBackofficeSdk.credits.makePaid(body, () => {
          this.$refs.listCr.loadData(1)
        })
      },
    },
    computed: {
      search() {
        return {
          client_id: this.$route.params.id,
          type: this.type
        }
      },
      ...mapState({
        configuration: state => state.configuration,
      }),
      topupSizes() {
        const sizes = this.configuration.system.system_fields_configuration.value.find((item) => {
          return item.field === 'topup_sizes'
        })

        return sizes ? sizes.config.split(',') : []
      }
    },
    props: ['type']
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// PaidCreditRecords.vue?7d83ddd9